export default __webpack_public_path__ + "static/media/Icon-Arrow_Gray.e5892641.svg";